import { Media } from './media';

export class Lesson {
    id: number;
    title: string;
    description: string;
    rating: number;
    points: number;
    media_id: number;
    media: Media;
    course_id:number;
    vimeo_id:number;
    order:number;
    free:boolean;
    meta:any;
    duration:number;
    constructor(lesson?) {
        if (lesson) {
            this.id = lesson.id;
            this.title = lesson.title;
            this.description = lesson.description || '';
            this.media = lesson.media;
            this.rating = lesson.rating;
            this.points = lesson.points;
            this.media_id = lesson.media_id;
            this.course_id = lesson.course_id;
            this.vimeo_id = lesson.vimeo_id;
            this.order = lesson.order;
            this.free  = lesson.free;
            this.duration = lesson.duration || 0;
            ;
        }
    }
}
